import React from 'react';
import {
  Card,
  CardHeader,
  CardSection,
  ParagraphHeader,
  ReadonlyTextarea,
  SmallHeader,
  Gutter,
} from '@axiom/ui';
import type { UseOnboardingTextReturn } from '@axiom/ui';

import type { Nullable } from '../../types/utility.types';

export type OnboardingLegalProps = {
  name: string;
  legalText: Nullable<
    Pick<
      NonNullable<ReturnType<UseOnboardingTextReturn['getOnboardingTexts']>>,
      | 'describingAxiom'
      | 'supportResources'
      | 'communications'
      | 'workLocationWorkingRemotely'
    >
  >;
};

export const OnboardingLegal = ({ name, legalText }: OnboardingLegalProps) => {
  return (
    <Card name={name}>
      <CardHeader>
        <SmallHeader>Legal</SmallHeader>
      </CardHeader>
      <CardSection>
        {legalText.describingAxiom ? (
          <>
            <ParagraphHeader>Describing Axiom:</ParagraphHeader>
            <Gutter bottom="8px" />
            <ReadonlyTextarea
              name="DESCRIBING_AXIOM"
              value={legalText.describingAxiom}
              formatting="modern"
            />
            <Gutter bottom="24px" />
          </>
        ) : null}
        {legalText.supportResources ? (
          <>
            <ParagraphHeader>Support and Resources:</ParagraphHeader>
            <Gutter bottom="8px" />
            <ReadonlyTextarea
              name="SUPPORT_AND_RESOURCES"
              value={legalText.supportResources}
              formatting="modern"
            />
          </>
        ) : null}
        <Gutter bottom={legalText.communications ? '8px' : '0px'} />
        {legalText.communications ? (
          <ReadonlyTextarea
            name="COMMUNICATIONS"
            value={legalText.communications}
            formatting="modern"
          />
        ) : null}
        {legalText.workLocationWorkingRemotely ? (
          <Gutter top="24px">
            <ParagraphHeader>Work Location & Working Remotely:</ParagraphHeader>
            <Gutter bottom="8px" />
            <ReadonlyTextarea
              name="WORK_LOCATION_WORKING_REMOTELY"
              value={legalText.workLocationWorkingRemotely}
              formatting="modern"
            />
          </Gutter>
        ) : null}
      </CardSection>
    </Card>
  );
};
